@if (!showForm()) {
  <div class="form-row margin--bottom-l">
    <button mat-raised-button color="secondary" (click)="showCreateForm()">
      <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
      Opret prisregulering
    </button>
  </div>
}

@if (showForm()) {
  <form [formGroup]="form" class="table-width margin--bottom-l">
    <div class="form-row">
      <mat-form-field title="Navn">
        <mat-label>Navn</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field title="Type">
        <mat-label>Type</mat-label>
        <mat-select formControlName="type">
          <mat-option [value]="PriceRegulationType.Discount">{{ PriceRegulationType.Discount | translatePriceRegulationType }}</mat-option>
          <mat-option [value]="PriceRegulationType.SupplementOverride">{{
            PriceRegulationType.SupplementOverride | translatePriceRegulationType
          }}</mat-option>
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>

    @if (selectedType() === PriceRegulationType.Discount) {
      <div class="form-row">
        <adm-price-ex-incl-vat
          headline="Rabat"
          formControlNameExclVat="discountAmountInKrWithoutVat"
          [initialExclVat]="form.controls.discountAmountInKrWithoutVat.value"
          formControlNameInclVat="discountAmountInKrWithoutVat" />
        @if (form.controls.discountAmountInKrWithoutVat.touched && form.controls.discountAmountInKrWithoutVat.hasError('required')) {
          <mat-error class="standalone-error">Indtast venligst et tillæg </mat-error>
        }
        @if (
          form.controls.discountAmountInKrWithoutVat.touched &&
          (form.controls.discountAmountInKrWithoutVat.hasError('min') || form.controls.discountAmountInKrWithoutVat.hasError('max'))
        ) {
          <mat-error class="standalone-error">Værdi skal være 0-100 </mat-error>
        }
      </div>
    }

    @if (selectedType() === PriceRegulationType.SupplementOverride) {
      <div class="form-row supplement-row">
        <mat-slide-toggle formControlName="overrideOkSupplement">Overskriv OK-tillæg</mat-slide-toggle>
        @if (form.controls.overrideOkSupplement.value) {
          <adm-price-ex-incl-vat
            headline="OK-tillæg"
            formControlNameExclVat="okSupplementOverrideInKrWithoutVat"
            [initialExclVat]="form.controls.okSupplementOverrideInKrWithoutVat.value"
            formControlNameInclVat="okSupplementOverrideInKrWithoutVat" />
          @if (
            form.controls.okSupplementOverrideInKrWithoutVat.touched &&
            form.controls.okSupplementOverrideInKrWithoutVat.hasError('required')
          ) {
            <mat-error class="standalone-error"> Indtast venligst et tillæg </mat-error>
          }
          @if (
            form.controls.okSupplementOverrideInKrWithoutVat.touched &&
            (form.controls.okSupplementOverrideInKrWithoutVat.hasError('min') ||
              form.controls.okSupplementOverrideInKrWithoutVat.hasError('max'))
          ) {
            <mat-error class="standalone-error">Værdi skal være 0-100 </mat-error>
          }
        }
      </div>

      <div class="form-row supplement-row">
        <mat-slide-toggle formControlName="overrideOrganizationSupplement">Overskriv kundetillæg</mat-slide-toggle>
        @if (form.controls.overrideOrganizationSupplement.value) {
          <adm-price-ex-incl-vat
            headline="Kundetillæg"
            formControlNameExclVat="organizationSupplementOverrideInKrWithoutVat"
            [initialExclVat]="form.controls.organizationSupplementOverrideInKrWithoutVat.value"
            formControlNameInclVat="organizationSupplementOverrideInKrWithoutVat" />
          @if (
            form.controls.organizationSupplementOverrideInKrWithoutVat.touched &&
            form.controls.organizationSupplementOverrideInKrWithoutVat.hasError('required')
          ) {
            <mat-error class="standalone-error">Indtast venligst et tillæg </mat-error>
          }
          @if (
            form.controls.organizationSupplementOverrideInKrWithoutVat.touched &&
            (form.controls.organizationSupplementOverrideInKrWithoutVat.hasError('min') ||
              form.controls.organizationSupplementOverrideInKrWithoutVat.hasError('max'))
          ) {
            <mat-error class="standalone-error">Værdi skal være 0-100 </mat-error>
          }
        }
      </div>

      @if (form.hasError('supplementOverrideRequired') && form.touched) {
        <mat-error class="standalone-error">Vælg mindst ét tillæg, der skal overskrives</mat-error>
      }
    }

    <div class="form-row flex">
      <button mat-button type="button" (click)="cancelCreate()" class="margin--left-auto margin--right-m">Annuller</button>
      <button mat-raised-button color="secondary" type="button" (click)="createPriceRegulation()" [disabled]="form.invalid || !form.dirty">
        {{ editMode() ? 'Gem prisregulering' : 'Opret prisregulering' }}
      </button>
    </div>
  </form>
}
